// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import head from 'vue-head';
import App from '@/App';
import router from '@/router';
import store from '@/store';
import i18n from "@/locales";
import Vuelidate from 'vuelidate';
import ToggleButton from 'vue-js-toggle-button';
import {HTTP} from "@/helpers/http-common";
import Datetime from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import "vue-swatches/dist/vue-swatches.min.css";
import VueBreadcrumbs from 'vue-breadcrumbs';
import VueScrollTo from 'vue-scrollto';
import VueSweetalert2 from 'vue-sweetalert2';
import {validateCheckListAfterRefresh} from "@/helpers/app-refresh-check-list";
import BootstrapVue from 'bootstrap-vue';
import VueUserPermissions from '@/plugins/vue-user-permissions';
import MaskedInput from 'vue-text-mask';
import IdleVue from 'idle-vue';
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import Vuetify from 'vuetify';
import colors from 'vuetify/es5/util/colors'
import '@/components/vuetify/css/vuetify.min.css';
import '@mdi/font/css/materialdesignicons.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueCircleSlider from 'vue-circle-slider'
import Croppa from 'vue-croppa';
import 'vue-croppa/dist/vue-croppa.css';
import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'
import 'chartist/dist/chartist.css'
import '@/components/chartist/css/chartist-plugin-tooltip.css'
import chartist from 'vue-chartist'
import chartist_tooltip from 'chartist-plugin-tooltips'
import es from '@/components/vuetify/locale/es'
import FOSBitacora from '@/plugins/bitacora';

 

Vue.config.productionTip = false;
Vue.config.devtools = true

// Add plugins
Vue.use(chartist,{
	plugins: [
	     chartist_tooltip
  ]
});
Vue.use(VueChartkick, {adapter: Chart})
Vue.use(head);
Vue.use(Vuelidate);
Vue.use(ToggleButton)
Vue.use(Datetime);
Vue.use(VueBreadcrumbs,{
  template:
    '<v-breadcrumbs v-if="$breadcrumbs.length"><v-icon slot="divider">forward</v-icon>'
      +'<v-breadcrumbs-item  v-for="(crumb,index) of $breadcrumbs">'
      + '<router-link class="breadcrumb-item" style="color:gray" :to="linkProp(crumb)" :key="index">{{ crumb | crumbText }}</router-link> ' 
      +'</v-breadcrumbs-item>'
    +'</v-breadcrumbs>'
});
Vue.use(VueScrollTo);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(VueUserPermissions, { router, store, strict:true, defaultRoute:'Feeds' });
Vue.use(FOSBitacora,router);
Vue.component('masked-input', MaskedInput);
Vue.use(IdleVue, {
  eventEmitter: new Vue(),
  idleTime: (100000 * 60)
})
Vue.use(Vuetify, {
  theme: {
    primary: colors.blue.darken3, // #E53935
    secondary: colors.blue.lighten2, // #FFCDD2
    accent: colors.blue.accent3 // #3F51B5
  }
  , options:{
    toolbarFormOption:{
      dense:true //Activa tamaño reducido
    }
  }
  ,lang: {
    locales: { es },
    current: 'es'
  }
});
Vue.use(VueCircleSlider)
Vue.use(Croppa, { componentName: 'croppa' })




// if you don't want install the component globally
//Vue.use(VueYouTubeEmbed, { global: false })

/* eslint-disable no-new */
export default new Vue({
  el: '#app'
  //localStorage
  , beforeCreate(){
    validateCheckListAfterRefresh(this.$store, HTTP, this.$userPermission);
  }
  , router
  , store
  , i18n
  //Validación de inactividad.
  , onIdle() {
    //Valida Sesión
    if(this.$store.getters.getUserIsAuthenticated){
      const {username} = this.$store.getters.getUserData;
      EventBus.$emit(events.SESSION_TIME_FINISHED, {username});
    }
  }
  , onActive() {}
  , components: { App }
  , template: '<App/>'
});

//export default app;



// WEBPACK FOOTER //
// ./src/main.js